<template>
  <div class="pageStyle">
    <div class="title">长按图片保存分享</div>
    <div class="content">
      <van-swipe class="my-swipe" indicator-color="#4988fd">
        <van-swipe-item v-for="item in 1" :key="item"
          ><div class="item">
            <div class="item-box">
              <img :src="posterUrl" alt="" />
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="foot">
      <div>
        <span @click="toCopyUrl()">复制链接</span
        ><span @click="timePopup = !timePopup">二维码有效期</span>
      </div>
    </div>
    <!-- 准入地区弹窗 -->
    <van-popup
      v-model="timePopup"
      position="bottom"
      round
      style="max-height: 70%"
    >
      <div class="timePopup">
        <div class="title">选择二维码有效期</div>
        <div>
          <span
            :class="timeValue == item.value ? 'choice' : ''"
            v-for="(item, index) in timeOptions"
            :key="index"
            @click="choiceTime(item.value)"
            >{{ item.label }}</span
          >
        </div>
        <div>*当超过有效期，二维码即失效，打开为失效页面</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem, Icon, Toast } from "vant";
import { getMcode, getPoster } from "@/api/product.js";
Vue.use(Swipe);
Vue.use(Icon);
Vue.use(SwipeItem);
Vue.use(Toast);
export default {
  data() {
    return {
      posterUrl: "",
      applyUrl:"",
      // 选择时间弹窗
      timePopup: false,
      // 有效期文字
      timeTxt: "",
      mCode: "",
      // 时效码时间
      timeValue: 4320,
      // 选择时效码时间
      timeOptions: [
        {
          value: 10,
          label: "10分钟",
        },
        {
          value: 60,
          label: "1小时",
        },
        {
          value: 720,
          label: "12小时",
        },
        {
          value: 1440,
          label: "24小时",
        },
        {
          value: 4320,
          label: "3天",
        },
        {
          value: 14400,
          label: "10天",
        },
        {
          value: 21600,
          label: "15天",
        },
        {
          value: 43200,
          label: "30天",
        },
        {
          value: 0,
          label: "无限制",
        },
      ],
      productId: "",
    };
  },

  mounted() {
    this.productId = this.$route.query.productId;
    // 获取时效码海报 默认3天
    this.choiceTime(4320);
  },

  methods: {
    loadPosterPage(productId, minutes) {
      getPoster(productId, minutes).then((res) => {
        this.posterUrl = res.imgUrl;
        this.applyUrl =  res.applyUrl;
        Toast.clear();
      });
    },
    // 选择时效码时间（分）
    choiceTime(time) {
      this.timeValue = time;
      this.loadPosterPage(this.productId, this.timeValue);
      this.timePopup = !this.timePopup;
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
    },
    getFutureTime(minutes) {
      const now = new Date();
      const future = new Date(now.getTime());
      future.setMinutes(
        now.getMinutes() + minutes,
        now.getSeconds(),
        now.getMilliseconds()
      );
      this.timeTxt = this.formatTime(future);
    },
    toCopyUrl() {
      let textarea = document.createElement("textarea");
      document.body.appendChild(textarea);
      // 赋值内容
      textarea.value = this.applyUrl;
      // 选定
      textarea.select();
      // 执行浏览器复制
      document.execCommand("Copy");
      // 复制完后移除textarea
      document.body.removeChild(textarea);
      Toast.success("已复制");
    },
    formatTime(date) {
      function padZero(num) {
        return num < 10 ? "0" + num : num;
      }
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1); // getMonth() 返回的月份是从 0 开始的
      let day = padZero(date.getDate());
      let hours = padZero(date.getHours());
      let minutes = padZero(date.getMinutes());
      let seconds = padZero(date.getSeconds());
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/productPoster/index.vue